import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { HistoricWorkflowClient } from "../../../../../Wrap/Api/Instruction/HistoricWorkflow";
import { DemandType } from "../../../../../Wrap/Models/Domains/Workflow/DemandType";

export interface IHistoricWorkflowSearchQuery {
    startDate: Date;
    endDate: Date;
    demandType: DemandType;
    policyNumber: string;
}

export class HistoricWorkflowAction {
    public static searchHistoricWorkflows(
        query: IHistoricWorkflowSearchQuery,
        currentPage,
        count,
        callBack?: (val: any) => void
    ): void {
        const client = new HistoricWorkflowClient();
        const promise = client.get(
            JsonDateParser.toJsonDateNoOffset(query.startDate),
            JsonDateParser.toJsonDateNoOffset(query.endDate),
            query.demandType,
            query.policyNumber,
            currentPage,
            count
        );
        promise.onSuccess((res) => {
            callBack(res);
        });
    }
}
